import React, {Component} from 'react';
import { connect } from 'react-redux';
import {verifyRegisterPhone} from '../../action/investmentAction.js';
import {getCapcha,forgetPassword,getMobileCaptcha} from '../../action/loginAction.js';
import NavigatorMain from '../NavigatorMain';
import Util from '../../util.js';
import { Toast } from 'antd-mobile/lib';
import { hashHistory } from 'react-router';

let intervalId = null;
let requestId = "";

class VerifyDynamicCodeSec extends Component{
  state = {
    mobileNumber: "",
    mobileDynamicCode: '',
    isRequestingVerifyCode: false,
    countdown: 120,
    flag: false,
    captchaCode: "",
    serverCapchaCode: "",
    imageBase64: "",
    passWord: "",
    passWordSec: "",
    showHideFlag: true,
    showHideFlagSec: true
  }

  handleVerify = () => {
    if(!(/^1[0123456789]\d{9}$/.test(this.state.mobileNumber))){
      Toast.info('请输入正确的手机号码', 2);
      return ;
    }
    if(!/\S/.test(this.state.captchaCode)){
      Toast.info('请输入图形验证码', 2);
      return ;
    }
    if(requestId === '' || !requestId){
      Toast.info('请先申请手机验证码', 2);
      return ;
    }
    let encryptedPassword = Util.encrypt(this.state.passWord);

    let pattern = /^[\d,\w]{6,8}$/;
    if(!pattern.test(this.state.passWord)){
      Toast.info('密码格式不正确', 2);
      return;
    }
    if(this.state.passWord != this.state.passWordSec){
      Toast.info('密码不一致', 2);
      return;
    }
    let verifyParam = {
      requestId : requestId,
      mobileNo : this.state.mobileNumber,
      captcha : this.state.mobileDynamicCode,
      newPassword: encryptedPassword,
    }
    console.log(verifyParam)
    this.setState({
      flag: true
    })
    this.props.dispatch(forgetPassword(verifyParam, (msg)=>{this.syncSuccess(msg)}, (msg)=>{this.syncError(msg)}));
  }

  syncError = (msg) => {
    this.setState({
      flag: false
    });
    Toast.info(msg, 2);
  }

  syncSuccess = () => {
    this.setState({
      flag: false
    });
    //跳转到登录前的页面。
    // Toast.info(msg, 2);
    hashHistory.go(-1);
  }

  handleWaitingForVerifyDynamicCodeSec = () => {
    if(!(/^1[0123456789]\d{9}$/.test(this.state.mobileNumber))){
      Toast.info('请输入正确的手机号码', 2);
      return ;
    }
    if(!/\S/.test(this.state.captchaCode)){
      Toast.info('请输入图形验证码', 2);
      return ;
    }
    this.props.dispatch(verifyRegisterPhone({mobileNo: this.state.mobileNumber}, ()=>{this.verifyRegisterPhoneSuc()}, (msg)=>{this.verifyRegisterPhoneErr(msg)}));
  }

  verifyRegisterPhoneSuc(){
    Toast.info("该手机号码为未注册号码，请确认输入正确手机号码", 2);
  }

  verifyRegisterPhoneErr(msg){
    if(msg.indexOf('手机号已注册') != -1) {
      let params = {
        mobileNo: this.state.mobileNumber,
        token: this.state.serverCapchaCode,
        captchaCode: this.state.captchaCode.toUpperCase()
      }
      console.log(params);
      this.props.dispatch(getMobileCaptcha(params,(requestId)=>{this.getMobileCaptchaSucc(requestId)},(content)=>{this.getMobileCaptchaErr(content)}));
    }else {
      Toast.info(msg, 2);
    }
  }

  //图形验证码验证成功并获取短信验证码
  getMobileCaptchaSucc(_requestId){
    console.log(_requestId);
    requestId = _requestId; 
    let countNum = 119;
    this.setState({isRequestingVerifyCode: true, countDown: countNum}, ()=>{
      intervalId = setInterval(() => {
        countNum--;
        if(countNum < 0){
          cancelTimeOut();
          this.setState({
            isRequestingVerifyCode: false
          });
        }
        this.setState({
          countDown: countNum
        })
      }, 1000);
      const cancelTimeOut = () => {
        if(intervalId)
          clearInterval(intervalId);
        intervalId = null;
      }
    });
  }

  //图形验证码验证失败
  getMobileCaptchaErr(err){
    Toast.info(err.message, 2);
    requestId = "";
    this.setState({
      captchaCode: ""
    });
    this.getPicCaptchaFun();
  }

  componentWillUnmount(){
    requestId = '';
    this.setState({
      flag: false
    })
    if(intervalId)
      clearInterval(intervalId);
  }

  goBack = () => {
    hashHistory.goBack();
  }

  componentWillMount() {
    document.title = "找回登录密码";
    this.getPicCaptchaFun();
  }

  //获取图形验证码
  getPicCaptchaFun = () => {
    this.props.dispatch(getCapcha((token, base64) => {
      this.setState({
        imageBase64: base64,
        serverCapchaCode: token
      });
    }, () => {

    }));
  }

  showHidePass = () => {
    this.setState({
      showHideFlag: !this.state.showHideFlag
    })
  }

  showHidePassSec = () => {
    this.setState({
      showHideFlagSec: !this.state.showHideFlagSec
    })
  }

  render(){
    return (
      <div className="mainBox"> 
        <NavigatorMain>
          <div className="boxHeader">
            <div>
              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
            </div>
            <div>
              <span>找回登录密码</span>
            </div>
            <div>
              
            </div>
          </div>
        </NavigatorMain> 
        <div className="boxContent">
          <div style = {{
            width:'auto',
            height: 45,
            borderBottom: "1px solid  rgba(242,245,247,1)",
            backgroundColor: '#ffffff',
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            display: "-webkit-flex"
          }}>
            <span style = {{
              color: '#3a3e47',
              marginLeft: 13,
              fontSize: 13,
              width: 90
            }}>手机号</span>
            <div style = {{
              display: "-webkit-flex",
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              WebkitFlex: 1
            }}>
              <div style={{WebkitFlex: 1, paddingRight: 10}}>
                <input autocomplete="off" type = "text" style = {{color: "#3a3e47", fontSize: 13, width: "100%"}} placeholder = '请输入注册手机号' value = {this.state.mobileNumber} onChange = {(event)=>{this.setState({mobileNumber:event.target.value})}} />
              </div>        
            </div>
          </div>
          <div style = {{
            width:'auto',
            height: 45,
            borderBottom: "1px solid  rgba(242,245,247,1)",
            backgroundColor: '#ffffff',
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            display: "-webkit-flex"
          }}>
            <span style = {{
              color: '#3a3e47',
              marginLeft: 13,
              fontSize: 13,
              width: 90
            }}>图形验证码</span>
            <div style = {{
              display: "-webkit-flex",
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              WebkitFlex: 1
            }}>
              <div style={{WebkitFlex: 1, paddingRight: 13, display: "-webkit-flex", WebkitAlignItems: "center"}}>
                <input autocomplete="off" type = "text" style = {{color: "#3a3e47", fontSize: 13, width: "100%"}} placeholder = '请输入图形验证码' value = {this.state.captchaCode} onChange = {(event)=>{this.setState({captchaCode:event.target.value})}} />
                <div onClick={this.getPicCaptchaFun}>
                  <img style={{
                    width: 63,
                    height: 27
                  }} src={`data:image/png;base64,${this.state.imageBase64}`} />
                </div>
              </div>        
            </div>
          </div>
          <div style = {{
            width:'auto',
            height: 45,
            borderBottom: "1px solid  rgba(242,245,247,1)",
            backgroundColor: '#ffffff',
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            display: "-webkit-flex"
          }}>
            <span style = {{
              color: '#3a3e47',
              marginLeft: 13,
              fontSize: 13,
              width: 90
            }}>手机动态码</span>
            <div style = {{
              display: "-webkit-flex",
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              WebkitFlex: 1
            }}>
              <div style={{WebkitFlex: 1, paddingRight: 10}}>
                <input autocomplete="off" type = "text" style = {{color: "#3a3e47", fontSize: 13, width: "100%"}} placeholder = '请输入短信验证码' value = {this.state.mobileDynamicCode} onChange = {(event)=>{this.setState({mobileDynamicCode:event.target.value})}} />
              </div>
              {
                this.state.isRequestingVerifyCode ? 
                <div style = {{
                  backgroundColor: '#d8dbdd',
                  height: 27,
                  borderRadius: 13,
                  paddingLeft: 10,
                  paddingRight:10,
                  WebkitAlignItems: 'center',
                  WebkitJustifyContent: 'center',
                  display: "-webkit-flex",
                  marginRight: 10,
                  width: 110
                }}>
                  <span style = {{color: "#5b6370", fontSize: 13}}>{this.state.countDown}秒后重发</span>
                </div>
                :
                <div style={{whiteSpace: "nowrap", width: 110, textAlign: "right", paddingRight: 13}}>
                  <span  onClick = {this.handleWaitingForVerifyDynamicCodeSec} style = {{
                    color: '#fa063a',
                    fontSize: 13
                  }} >获取验证码</span>
                </div>
              }         
            </div>
          </div>
          <div style = {{
            width:'auto',
            height: 45,
            borderBottom: "1px solid  rgba(242,245,247,1)",
            backgroundColor: '#ffffff',
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            display: "-webkit-flex"
          }}>
            <span style = {{
              color: '#3a3e47',
              marginLeft: 13,
              fontSize: 13,
              width: 90
            }}>新登录密码</span>
            <div style = {{
              display: "-webkit-flex",
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              WebkitFlex: 1
            }}>
              <div style={{WebkitFlex: 1, paddingRight: 13, display: "-webkit-flex", WebkitAlignItems: "center"}}>
                <input autocomplete="off" type={this.state.showHideFlag ? "password" : "text"} style = {{color: "#3a3e47", fontSize: 13, width: "100%"}} placeholder = '请输入6-8位登录密码' value = {this.state.passWord} onChange = {(event)=>{this.setState({passWord:event.target.value})}} />
                <div onClick={this.showHidePass}>
                  {
                    this.state.showHideFlag ?
                    <img style={{
                      width: 55,
                      height: 55,
                      marginRight: -16
                    }} src={require("../../img/password_hide.png")} />
                    :
                    <img style={{
                      width: 55,
                      height: 55,
                      marginRight: -16
                    }} src={require("../../img/password_unhide.png")} />
                  }
                </div>
              </div>        
            </div>
          </div>
          <div style = {{
            width:'auto',
            height: 45,
            borderBottom: "1px solid  rgba(242,245,247,1)",
            backgroundColor: '#ffffff',
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            display: "-webkit-flex"
          }}>
            <span style = {{
              color: '#3a3e47',
              marginLeft: 13,
              fontSize: 13,
              width: 90
            }}>确认密码</span>
            <div style = {{
              display: "-webkit-flex",
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              WebkitFlex: 1
            }}>
              <div style={{WebkitFlex: 1, paddingRight: 13, display: "-webkit-flex", WebkitAlignItems: "center"}}>
                <input autocomplete="off" type={this.state.showHideFlagSec ? "password" : "text"} style = {{color: "#3a3e47", fontSize: 13, width: "100%"}} placeholder = '请重新输入密码' value = {this.state.passWordSec} onChange = {(event)=>{this.setState({passWordSec:event.target.value})}} />
                <div onClick={this.showHidePassSec}>
                  {
                    this.state.showHideFlagSec ?
                    <img style={{
                      width: 55,
                      height: 55,
                      marginRight: -16
                    }} src={require("../../img/password_hide.png")} />
                    :
                    <img style={{
                      width: 55,
                      height: 55,
                      marginRight: -16
                    }} src={require("../../img/password_unhide.png")} />
                  }
                </div>
              </div>        
            </div>
          </div>
          <div  style = {{
            marginTop: 15,
            marginLeft: 13,
            marginRight: 13,
            borderRadius: 20
          }}  onClick = {this.state.mobileDynamicCode && this.state.mobileNumber && this.state.passWord && this.state.passWordSec && this.state.captchaCode ? this.handleVerify : null }>
            <div style = {{backgroundColor: this.state.mobileDynamicCode && this.state.mobileNumber && this.state.passWord && this.state.passWordSec && this.state.captchaCode ? '#fa063a' : '#afb0b2' ,WebkitAlignItems: 'center',WebkitJustifyContent: 'center',height: 40,borderRadius: 20,WebkitFlexDirection: 'row',display: "-webkit-flex"}}>
              <span style = {{color: '#ffffff', fontSize: 15}}>下一步</span>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
  }
}

export default connect(mapStateToProps)(VerifyDynamicCodeSec);


// WEBPACK FOOTER //
// ./src/components/login/VerifyDynamicCodeSec.js